export const CategoryKeys = {
  allCategories: ['Categories'] as const,
  listCategories: () =>
    [...CategoryKeys.allCategories, 'listCategories'] as const,
  listCategory: () => [...CategoryKeys.listCategories(), {}] as const,
}
